<template>
    <div v-if="isPc" :class="['products-container']">
            <div class="loan-service-container" v-for="(service, index) in loanServices" :class="{ 'last-item': index === loanServices.length - 1 }"
        :key="index">
            <div class="loan-service-header">
                <div class="img-container">
                    <img :src="service.img" class="background-image" loading="lazy" />
                </div>
                <span class="service-description">{{ service.desc }}</span>
            </div>
            <div class="separator-line"></div>
            <div class="features-list">
                <div class="feature-item" v-for="(feature, index) in service.features" :key="'feature'+index" >
                    <div class="bullet-point"></div>
                    <span class="feature-text">{{ feature }}</span>
                </div>
        </div>
        </div>
    </div>
    <div v-else class="mob-products-container">
            <div class="top-img-container">
                <img :src="topImg" class="top-img" loading="lazy" />
            </div>
            <div class="products">
                <div class="product" v-for="(service, index) in loanServices" :key="index" :class="{ 'mob-last-item': index === loanServices.length - 1 }">
                    <div class="product-img-container">
                        <img :src="service.img_mob" class="product-img" loading="lazy" />
                    </div>
                    <div class="mob-features-list">
                        <div class="mob-feature-item" v-for="(feature, index) in service.features" :key="'feature'+index" :class="{ 'mob-feature-item-last-col': (index + 1) % 2 === 0, 'mob-feature-item-last-row': index >= service.features.length - 2 }">
                            <div class="mob-bullet-point"></div>
                            <span class="mob-feature-text">{{ feature }}</span>
                        </div>
                    </div>
                </div>
                <div class="bottom">*实际获得额度利率以审批为准</div>
            </div>
        </div>
</template>
<script>
import { dataReport } from "../../../../../../utils/report";

export default {
    props: {
        topImg: {
            type: String,
            default: ''
        },
        isPc: {
            type: Boolean,
            default: true
        },
        productInfo: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            topImage: 'https://coss-platform.fenqile.com/platformresource200/M00/ex/20251110172451-1b2f3252-5e0a-4334-b33f-8d77f2c7aefb.png',
        };
    },
    computed: {
        loanServices() {
            return this.productInfo?.[1]?.map(item => ({
                desc: item.title,
                img: item.img,
                img_mob: item.img_mob,
                features: item.text_list.flatMap(textObj =>
                    Object.keys(textObj)
                        .sort((a, b) => a.localeCompare(b, { numeric: true }))
                        .map(key => textObj[key]) // 提取值
                )
            }))
        }
    },
    methods: {
        handleExposure() {
            if(this.isPc){
                dataReport(
                {
                    hottag: "FQL_HOME_WEB_PRODUCTS_EXPOSURE",
                    eventPosName: `分期乐网页端首页产品项曝光`,
                    eventType: 1, // 曝光
                },
                {item:this.loanServices}
            );
            }
            else{
                dataReport(
                {
                    hottag: "FQL_HOME_MOB_PRODUCTS_EXPOSURE",
                    eventPosName: `分期乐移动端首页产品项曝光`,
                    eventType: 1, // 曝光
                },
                {item:this.loanServices}
            );
            }
        }
    },
    watch:{
        loanServices: {
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.handleExposure();
                }
            },
            deep: true
        }
    }
};
</script>

<style scoped>
.products-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    padding: 0;
}

.mob-products-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.products{
    width: 91%;
    padding-top: 30px;
    border: 1px solid #FFF;
    background: linear-gradient(180deg, rgba(175, 215, 255, 0.50) -17%, #FFF 23.63%);
    border-radius: 4px;
}

.product{
    margin-bottom:50px;
}

.loan-service-container {
    width:381px;
    height:397px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    padding-top: 53px;
    margin-right: 28px;
}

.background-image {
    width: 198px;
    height: auto;
}

.features-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.feature-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 14px;
}

.mob-feature-item {
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 15px;
    min-width: 120px;
}

.mob-feature-item-last-col {
    margin-right: 0;
}

.mob-feature-item-last-row {
    margin-bottom: 0;
}

.bullet-point {
    width: 4px;
    height: 4px;
    background-color: #4D83FF;
    border-radius: 50%;
    margin-right: 8px;
    margin-top:10px
}

.mob-bullet-point {
    width: 1vw;
    height: 1vw;
    background-color: #4D83FF;
    border-radius: 50%;
    margin-right: 8px;
}

.feature-text {
    color: rgba(65, 65, 65, 0.80);
    font-family: 'PingFang SC';
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
}

.separator-line {
    width: 300px;
    height: 1px;
    background-color: #DFDFDD;
    margin-top: 16px;
    margin-bottom: 46px;
    opacity: 0.5;
}

.service-description {
    color: #808080;
    font-family: 'PingFang SC';
    font-size: 14px;
    font-weight: 400;
}

.loan-service-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    height:94px;
}

.img-container {
    height: 50px;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;     /* 垂直居中 */
}

.product-img-container {
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;     /* 垂直居中 */
}



.last-item {
    margin-right: 0;
}

.mob-last-item {
    margin-bottom: 30px;
}

.top-img-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 21px;
}

.top-img {
    width: 79.7vw;
    height: 12.8vw;
}

.mob-features-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
}

.mob-feature-text {
    color: rgba(30, 37, 51, 0.80);
    font-family: 'PingFang SC';
    font-size: 3.6vw;
    font-weight: 400;
}

.product-img{
    width: 25.4vw;
    height: auto;
    margin-bottom: 16px;
}

.bottom{
    color: rgba(30, 37, 51, 0.50);
    font-family: 'PingFang SC';
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 32px;
}
</style>